import { Box, Typography, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { AppointmentCountRecurrent, AppointmentPet, status as AppointmentStatus } from '@spike/appointment-model';
import {
    AppointmentsStatus,
    changeAppointmentNotesThunk,
    countRecurrentAppointmentsThunk,
    deleteAppointmentThunk
} from '@spike/bookings-action';
import Client from '@spike/client-model';
import { ClientsStatus, getClientThunk } from '@spike/clients-action';
import Invoice from '@spike/invoice-model';
import {
    createDepositInvoiceThunk,
    getInvoiceThunk,
    InvoicesStatus,
    reset as resetInvoices
} from '@spike/invoices-action';
import { OWNER_ID, Period } from '@spike/model';
import {
    ApplyScope,
    NewBookingAppointment,
    RecurringSeriesExtensionInfo,
    RecurringSeriesOccurrence
} from '@spike/new-booking-model';
import {
    cancelBookingEditScopeThunk,
    clearAppointmentEditScopeThunk,
    changeBookingStatusThunk,
    confirmBookingEditScopeThunk,
    deleteDepositThunk,
    extendRecurringSeriesThunk,
    fetchRecurringSeriesExtensionInfoThunk,
    INITIAL_BOOKING_EDIT_SCOPE_REQUEST,
    NewBookingsStatus,
    PendingBookingEdit,
    removeBookingAppointmentsThunk,
    saveMultipleBookingThunk
} from '@spike/new-bookings-action';
import {
    AppointmentOrderItem,
    Order,
    OrderItem,
    OrderizableTypes,
    OrderStatus,
    RedeemTypes,
    SaveOrderItemRedeem
} from '@spike/order-model';
import {
    cancelOrderEditScopeThunk,
    confirmOrderEditScopeThunk,
    deleteOrderItemThunk,
    deletePetFromOrderThunk,
    getOrderByAppointmentThunk,
    getOrderThunk,
    INITIAL_ORDER_EDIT_SCOPE_REQUEST,
    migrateBookingThunk,
    OrderEdit,
    OrderEditScope,
    OrdersStatus,
    reloadOrderThunk,
    removeOrderItemsScopedThunk,
    saveNotesThunk,
    saveOrderRedeemsThunk,
    verifyOutdatedThunk
} from '@spike/orders-action';
import { showSuccess } from '@spike/notifications-action';
import Pet from '@spike/pet-model';
import { fetchPetsThunk, PetsStatus } from '@spike/pets-action';
import useNonInitialEffect from '@versiondos/hooks';
import { fetchStaffThunk } from 'actions/staff/StaffActions';
import clsx from 'clsx';
import { daily } from 'components/Calendar3/CalendarHeader/CalendarSelector/CalendarSelector';
import InvoiceResume from 'components/Checkout2/InvoiceResume';
import RefreshModal from 'components/Checkout2/UI/RefreshModal';
import { getOrderStartTime, groupOrderItemsByPet, sortPets } from 'components/Checkout2/utils/OrderUtils';
import DeclineConfirmation from 'components/Notifications/UI/DeclineConfirmation';
import PetCard from 'components/PetCard';
import { CompleteReport, EditReport, ViewReport } from 'components/Reports';
import { Button, ConfirmDialog, OverDetail, OverFullWindow, SidePanel } from 'components/UI';
import CreateBookingDrawer from 'components/UI/CreateBookingDrawer';
import RecurringSeriesViewPanel from 'components/CreateBooking/RecurringSeries/View/RecurringSeriesViewPanel';
import { STACKED_PANELS_QUERY } from 'components/CreateBooking/RecurringSeries/panelDocking';
import RecurringEditScopeDialog from './UI/RecurringEditScopeDialog/RecurringEditScopeDialog';
import AppointmentEditScopeDialogContainer from './UI/RecurringEditScopeDialog/AppointmentEditScopeDialogContainer';
import { isOrderInRecurringSeries } from './isOrderInRecurringSeries';
import TwoWaySMSDrawer from 'components/UI/TwoWaySMSDrawer/TwoWaySMSDrawer';
import { useApiClientWrapper, useAuth, usePermissions, useTimeZone } from 'hooks';
import useOrganizationMarketplaces from 'hooks/useOrganizationMarketplaces';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import Staff from 'model/Staff';
import moment, { Moment } from 'moment-timezone';
import ClientView from 'pages/Client';
import { FunctionComponent, ReactNode, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import useRecurringSeriesChannel from 'WebSockets/useRecurringSeriesChannel';
import { useHistory } from 'react-router-dom';
import { RootState } from 'store';
import AddOrderItem from './AddOrderItem';
import AddPet from './AddPet';
import EditOrderItem from './EditOrderItem';
import InvoiceView from './InvoiceView';
import { OrderDetailProvider, useOrderDetailContext } from './OrderDetailContext';
import OrderDetailHeader from './OrderDetailHeader';
import OrderSubtotalResume from './OrderSubtotalResume';

import { AddEditEvaluationReport } from './AddEditEvaluationReport/AddEditEvaluationReport';
import { ReportBuilder } from 'components/Reports/DaycareBordingReportBuilder/ReportBuilder';
import ActivityHistoryDrawer from './Tabs/Activities/ActivityHistoryDrawer';
import OrderDetailActivitiesTab from './Tabs/Activities/OrderDetailActivitiesTab';
import { BookingBelongingsPage, SavedBookingBelonging } from '@spike/belonging-model';
import { BelongingsStatus, fetchBookingBelongingsThunk } from '@spike/belongings-action';
import OrderDetailBelongingsTab from './Tabs/Belongings/OrderDetailBelongingsTab';
import OrderDetailDetailsTab from './Tabs/Details/OrderDetailDetailsTab';
import OrderDetailFeedingTab from './Tabs/Feeding/OrderDetailFeedingTab';
import OrderDetailMedsTab from './Tabs/Meds/OrderDetailMedsTab';
import OrderDetailTasksTab from './Tabs/Tasks/OrderDetailTasksTab';
import { EvaluationReport } from '@spike/report-model';
import PrintBookingDetail from './UI/PrintBookingDetail/PrintBookingDetail';
import {
    ENROLLMENT_REDEEM_GET_ORDER_MAX_POLLS,
    ENROLLMENT_REDEEM_GET_ORDER_POLL_MS,
    findAppointmentOrderItemForRedeem,
    PendingEnrollmentRedeemPayload
} from './enrollmentRedeemUtils';
import {
    canAddToOrder,
    canEditAppointmentItems,
    getOrderClosedAtFromAppointments,
    OrderEditContext
} from 'utils/appointmentTransitionPolicy';
import { CollectDeposit } from 'components/CreateBooking/CollectDeposit/CollectDeposit';
import CreateBookingHeader from 'components/CreateBooking/CreateBookingHeader';
export interface OrderDetailProps {
    orderId?: number;
    bookingId: number;
    startInEditMode?: boolean;
    zIndex?: number;
    readOnly?: boolean;
    onClose: () => void;
    onOrderUpdated?: () => void;
    onCheckout?: (bookingId: number, orderId: number) => void;
    onRebookOrder?: () => void;
    onRebookService?: () => void;
    onShowActivityLog?: () => void;
    onViewResults?: (evaluationReport?: EvaluationReport) => void;
    className?: string;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        container: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            height: '100%'
        },
        horizontalPaddings: {
            paddingLeft: 32,
            paddingRight: 32,
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 16,
                paddingRight: 16
            }
        },
        headerContainer: {
            paddingTop: 37,
            paddingBottom: 18,
            [theme.breakpoints.down('sm')]: {
                paddingTop: 24,
                paddingBottom: 12
            }
        },
        tabs: {
            width: '100%',
            borderBottom: '1px solid #D4D4D4'
        },
        tabsScroller: {
            'gap': 24,
            'paddingTop': 8,
            'display': 'flex',
            'overflowX': 'auto',
            'scrollbarWidth': 'none',
            'msOverflowStyle': 'none',

            '&::-webkit-scrollbar': {
                display: 'none'
            }
        },
        tab: {
            'border': 'none',
            'appearance': 'none',
            'cursor': 'pointer',
            'fontFamily': 'Poppins',
            'backgroundColor': '#ffffff',
            'borderBottom': 'solid 2px transparent',
            'padding': '0px 0px 11px 0px',
            'fontSize': 16,
            'fontWeight': 500,
            'lineHeight': 1,
            'color': '#BCB8AE',
            'display': 'flex',
            'alignItems': 'center',
            'gap': 6,

            '&[data-active="true"]': {
                color: '#222222',
                borderBottom: 'solid 2px #000000'
            }
        },
        tabBadge: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: 20,
            height: 20,
            padding: '0 6px',
            borderRadius: 10,
            backgroundColor: '#F2D2A2',
            color: '#222222',
            fontSize: 11,
            fontWeight: 600,
            lineHeight: 1
        },
        scrollableContent: {
            flex: 1,
            overflowY: 'auto',
            paddingTop: 24
        },
        bodyContainer: {
            flex: 1,
            width: '100%',
            height: '100%',
            display: 'flex',
            overflowX: 'hidden',
            flexDirection: 'column'
        },
        bodyBottomSpace: {
            height: 1,
            border: '1px solid white',
            marginTop: 37,
            [theme.breakpoints.down('sm')]: {
                marginTop: 24
            }
        },
        footerContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingTop: 24,
            paddingBottom: 24,
            borderTop: '1px solid #D4D4D4',
            [theme.breakpoints.down('sm')]: {
                paddingTop: 12,
                paddingBottom: 12
            }
        },
        orderSpinnerContainer: {
            display: 'flex',
            height: '100%',
            justifyContent: 'center',
            alignItems: 'center'
        },
        addButtonSpinner: {
            width: '25px !important',
            height: '25px !important'
        },
        addButtonSpinnerContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: 42
        },
        checkoutButton: {
            height: 50,
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                borderRadius: 30
            },
            [theme.breakpoints.up('md')]: {
                height: 55
            }
        },
        section: {
            marginTop: 37,
            [theme.breakpoints.down('sm')]: {
                marginTop: 24
            }
        },
        petDetail: {
            marginTop: 24
        },
        latePickUpFee: {
            marginTop: 20
        },
        addAnotherPetButton: {
            'height': 43,
            'width': 'fit-content',
            'padding': '8px 16px !important',
            '& .MuiButton-label': {
                fontSize: 14,
                lineHeight: '27px'
            }
        },
        requestButtonsContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            gap: 12
        },
        declineButton: {
            width: '100%',
            height: 50,
            [theme.breakpoints.up('md')]: {
                height: 55
            }
        },
        editButton: {
            width: '100%',
            height: 50,
            [theme.breakpoints.up('md')]: {
                height: 55
            }
        },
        acceptButton: {
            width: '100%',
            height: 50,
            [theme.breakpoints.up('md')]: {
                height: 55
            }
        },
        requestSaveButton: {
            width: '100%',
            height: 50,
            [theme.breakpoints.up('md')]: {
                height: 55
            }
        },
        viewCalendarButton: {
            'marginTop': 24,
            'height': 43,
            'width': 'fit-content',
            'padding': '8px 16px !important',
            '& .MuiButton-label': {
                fontSize: 14,
                lineHeight: '27px'
            }
        },
        bookingDetailTitle: {
            fontSize: 20
        },
        time: {
            marginTop: 24
        },
        clientOverWindow: {
            zIndex: 99,
            [theme.breakpoints.down('sm')]: {
                left: 0
            },
            [theme.breakpoints.only('md')]: {
                left: '65px'
            },
            [theme.breakpoints.only('lg')]: {
                left: '62px'
            },
            [theme.breakpoints.between(1440, 1920)]: {
                left: '80px'
            },
            [theme.breakpoints.only('xl')]: {
                left: '80px'
            }
        },
        collectDepositDrawerRoot: {
            'display': 'flex',
            'flexDirection': 'column',
            'height': '100%',
            '& .MuiDrawer-paperAnchorRight': {
                width: '100%',
                [theme.breakpoints.up('lg')]: {
                    width: '590px !important'
                }
            }
        },
        collectDepositDrawerBody: {
            flex: 1,
            minHeight: 0,
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        },
        collectDepositHeaderWrap: {
            flexShrink: 0,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            margin: '17px 27px 16px 27px',
            [theme.breakpoints.up('md')]: {
                margin: '20px 30px 16px 30px'
            }
        },
        recurrencyContainer: {
            marginTop: 18,
            [theme.breakpoints.up('md')]: {
                marginTop: 24
            }
        },
        lastRecurrentAlertText: {
            fontSize: 16,
            fontHeigh: '18px'
        },
        lastRecurrentWarning: {
            marginTop: 22
        },
        extendButton: {
            marginTop: 10
        },
        invoiceResume: {
            width: '100%',
            borderTop: 'none',
            padding: 0,
            marginBottom: 18,
            [theme.breakpoints.up('md')]: {
                marginBottom: 24
            }
        },
        transparentBackdrop: {
            backgroundColor: 'transparent !important'
        }
    })
);

const cancelledStatus = [AppointmentStatus.CANCELLED, AppointmentStatus.NO_SHOW, AppointmentStatus.DECLINED];

const ORDER_EDIT_SCOPE_TITLES: Record<OrderEdit['type'], string> = {
    update_item: 'Edit Recurring Item',
    add_items: 'Add to Recurring Booking',
    remove_items: 'Remove from Recurring Booking'
};

const cleanRelatedEnrollmentFromOrderItem = (orderItem: OrderItem): OrderItem => {
    const clonedOrderItem = cloneDeep(orderItem);

    if (orderItem.redeem === undefined) {
        return clonedOrderItem;
    } else {
        clonedOrderItem.amount = clonedOrderItem.originalPrice ?? '0.00';
        clonedOrderItem.total = undefined;
    }

    return clonedOrderItem;
};

const removeRelatedEnrollments = (order: Order): Order => {
    order.items.appointments.forEach(
        appointmentItem => (appointmentItem.orderItem = cleanRelatedEnrollmentFromOrderItem(appointmentItem.orderItem))
    );
    order.items.addOnServices.forEach(
        addOnServiceItem =>
            (addOnServiceItem.orderItem = cleanRelatedEnrollmentFromOrderItem(addOnServiceItem.orderItem))
    );
    order.items.products.forEach(
        productItem => (productItem.orderItem = cleanRelatedEnrollmentFromOrderItem(productItem.orderItem))
    );

    return order;
};

const cleanUpOrderForRebook = (order: Order): Order => {
    const clonedOrder = cloneDeep(order);

    clonedOrder.items.appointments = clonedOrder?.items.appointments.filter(
        item => item.pet === undefined || (item.pet.active && !item.pet.deceased && !item.pet.deleted)
    );
    clonedOrder.items.addOnServices = clonedOrder?.items.addOnServices.filter(
        item => item.pet === undefined || (item.pet.active && !item.pet.deceased && !item.pet.deleted)
    );
    clonedOrder.items.products = clonedOrder?.items.products.filter(
        item => item.pet === undefined || (item.pet.active && !item.pet.deceased && !item.pet.deleted)
    );
    clonedOrder.items.customs = clonedOrder?.items.customs.filter(
        item => item.pet === undefined || (item.pet.active && !item.pet.deceased && !item.pet.deleted)
    );

    removeRelatedEnrollments(clonedOrder);

    return clonedOrder;
};

const cleanUpServiceForRebook = (appointmentItem: AppointmentOrderItem): AppointmentOrderItem => {
    const clonedappointmentItem = cloneDeep(appointmentItem);
    clonedappointmentItem.orderItem = cleanRelatedEnrollmentFromOrderItem(clonedappointmentItem.orderItem);

    return clonedappointmentItem;
};

type RecurringSeriesWatchReason = 'edit' | 'extend';

type RecurringSeriesExtension = 'idle' | 'requesting' | 'processing';

const SERIES_EXTENSION_FALLBACK_MS = 60000;

interface OrderDetailContentProps extends OrderDetailProps {
    isRecurringSeriesOpen: boolean;
    onOpenRecurringSeries: (recurringUuid: string) => void;
    onDrawerHiddenChange: (hidden: boolean) => void;
    onWatchRecurringSeries: (recurringUuid: string, reason?: RecurringSeriesWatchReason) => void;
    onRecurringSeriesFinished: (reason: RecurringSeriesWatchReason) => void;
    recurringSeriesFinishedKey: number;
    onRecurringSeriesUpdatingChange: (updating: boolean) => void;
    onRecurringSeriesChanged: () => void;
    recurringSeriesPanel?: ReactNode;
}

const OrderDetailContent: FunctionComponent<OrderDetailContentProps> = props => {
    const classes = useStyles(props);
    const { activeTab, setActiveTab } = useOrderDetailContext();

    const dispatch = useDispatch();
    const thunkDispatch = useDispatch<ThunkDispatch<RootState, null, AnyAction>>();
    const apiClientWrapper = useApiClientWrapper();
    const timezone = useTimeZone();
    const history = useHistory();
    const auth = useAuth();
    const permissions = usePermissions();
    const { isUserLoggedInMarketplace } = useOrganizationMarketplaces();

    const appointmentsStatus = useSelector<RootState, AppointmentsStatus>(state => state.appointments.status);

    // The client view (ClientView -> SellMembership -> Checkout2, or another booking opened from the
    // client) is rendered on top of this panel and loads *other* orders into the shared orders slice.
    // While it is open this panel keeps its own booking order and ignores slice updates, otherwise it
    // would re-render with an order that has no appointments and crash (SU-2424).
    const [showClientView, setShowClientView] = useState<{ clientId: number | undefined }>({
        clientId: undefined
    });
    const clientViewOpen = showClientView.clientId !== undefined;

    const storeOrder = useSelector<RootState, Order | undefined>(state => state.orders.order);
    const bookingOrderRef = useRef<Order | undefined>(undefined);
    const order = useMemo(() => {
        if (clientViewOpen && storeOrder && bookingOrderRef.current && storeOrder.id !== bookingOrderRef.current.id) {
            return bookingOrderRef.current;
        }
        bookingOrderRef.current = storeOrder;
        return storeOrder;
    }, [storeOrder, clientViewOpen]);
    const orderStatus = useSelector<RootState, OrderStatus | undefined>(state => state.orders.orderStatus);
    const ordersStatus = useSelector<RootState, OrdersStatus>(state => state.orders.status);
    const orderOutdated = useSelector<RootState, { order: boolean } | undefined>(state => state.orders.outdated);

    const client = useSelector<RootState, Client | undefined>(state => state.clients.client);
    const clientsStatus = useSelector<RootState, ClientsStatus>(state => state.clients.status);

    const recurrentInfo = useSelector<RootState, undefined | AppointmentCountRecurrent>(
        state => state.appointments.recurrent
    );

    const newBookingsStatus = useSelector<RootState, NewBookingsStatus>(state => state.newBookings.status);
    const orderEditScope = useSelector<RootState, OrderEditScope | undefined>(state => state.orders.orderEditScope);
    const orderEditScopeRef = useRef<OrderEditScope>();
    orderEditScopeRef.current = orderEditScope;
    const pendingBookingEdit = useSelector<RootState, PendingBookingEdit | undefined>(
        state => state.newBookings.bookingEditScope
    );

    const petsStatus = useSelector<RootState, PetsStatus>(state => state.pets.status);
    const clientPets = useSelector<RootState, Array<Pet>>(state => state.pets.list);

    const invoice = useSelector<RootState, Invoice | undefined>(state => state.invoices.invoice);
    const depositInvoice = useSelector<RootState, Invoice | undefined>(state => state.invoices.depositInvoice);
    const invoicesStatus = useSelector<RootState, InvoicesStatus>(state => state.invoices.status);

    const staffs = useSelector<RootState, Array<Staff>>(state => state.staff.staff);
    const bookingBelongingsPage = useSelector<RootState, BookingBelongingsPage | undefined>(
        state => state.belongings.bookingBelongingsPage
    );
    const savedBookingBelonging = useSelector<RootState, SavedBookingBelonging | undefined>(
        state => state.belongings.savedBookingBelonging
    );
    const belongingsStatus = useSelector<RootState, BelongingsStatus>(state => state.belongings.status);

    const orderMarketplaceId = order?.items.appointments[0]?.appointment.marketplaceId;
    const allowActions = orderMarketplaceId ? isUserLoggedInMarketplace(orderMarketplaceId) : true;
    const readOnly = props.readOnly ?? !allowActions;
    const orderDepositInvoiceId = order?.invoiceId ?? invoice?.id ?? depositInvoice?.id;

    const [loading, setLoading] = useState({
        order: true,
        services: false,
        invoice: true,
        pets: true,
        bookingStatus: false,
        recurrent: false,
        extend: false
    });

    const [edit, setEdit] = useState<{ order: boolean; orderItemId: number | undefined }>({
        order: !!props.startInEditMode,
        orderItemId: undefined
    });

    const [add, setAdd] = useState<{
        petId: number | undefined;
        orderItemType: OrderizableTypes | undefined;
        isEvaluation?: boolean;
    }>({
        petId: undefined,
        orderItemType: undefined,
        isEvaluation: false
    });

    const [showPetCard, setShowPetCard] = useState<{ petId: number | undefined; optionSelected: string | undefined }>({
        petId: undefined,
        optionSelected: undefined
    });

    const [showInvoiceView, setShowInvoiceView] = useState<{ invoice: Invoice | undefined }>({
        invoice: undefined
    });

    const [collectDepositOpen, setCollectDepositOpen] = useState(false);
    const [depositToggleSaving, setDepositToggleSaving] = useState(false);
    const [depositPendingResolved, setDepositPendingResolved] = useState(false);

    const [remove, setRemove] = useState<{
        orderItemId: number | undefined;
        type: OrderizableTypes | undefined;
        label: string;
        removing: boolean;
    }>({
        orderItemId: undefined,
        label: '',
        type: undefined,
        removing: false
    });

    const [removePet, setRemovePet] = useState<{
        petId: number | undefined;
        petName: string;
        removing: boolean;
    }>({
        petId: undefined,
        petName: '',
        removing: false
    });

    const [addPet, setAddPet] = useState(false);
    const [pendingEnrollmentRedeem, setPendingEnrollmentRedeem] = useState<PendingEnrollmentRedeemPayload | null>(null);
    const pendingEnrollmentRedeemRef = useRef<PendingEnrollmentRedeemPayload | null>(null);
    const enrollmentRedeemGetOrderRetriesRef = useRef(0);
    const enrollmentRedeemPollScheduledRef = useRef(false);
    const enrollmentRedeemPollTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const enrollmentRedeemFallbackReloadRef = useRef(false);
    const lastSavedNotesRef = useRef<string>('');

    const [showDeclineDialog, setShowDeclineDialog] = useState(false);

    const [notes, setNotes] = useState('');

    const [report, setReport] = useState<{
        appointmentId?: number;
        businessAreaId?: string;
        serviceId?: number;
        pet?: AppointmentPet;
        evaluationReportId?: number;
        preshow: 'add' | 'view' | 'report-builder' | 'none';
        show: 'add' | 'view' | 'edit' | 'report-builder' | 'none';
        emailConfirmed: boolean;
    }>({ preshow: 'none', show: 'none', emailConfirmed: false });

    const [savingStatusAppointmentId, setSavingStatusAppointmentId] = useState<number | undefined>();

    const [refreshModal, setRefreshModal] = useState({ show: false });
    const [showTwoWays, setShowTwoWays] = useState<boolean>(false);
    const [showPrint, setShowPrint] = useState(false);
    const [showActivityHistory, setShowActivityHistory] = useState<boolean>(false);
    const [selectedActivityPet, setSelectedActivityPet] = useState<Pet | undefined>(undefined);
    const [selectedBelongingsPet, setSelectedBelongingsPet] = useState<Pet | undefined>(undefined);

    const [rebook, setRebook] = useState<{
        order: Order | undefined;
        appointmentOrderItem: AppointmentOrderItem | undefined;
    }>({ order: undefined, appointmentOrderItem: undefined });

    const isDrawerHidden =
        !!rebook.order || !!rebook.appointmentOrderItem || !!showPetCard.petId || !!showClientView.clientId;

    const confirmedEditScope = useRef<ApplyScope>();

    const { onDrawerHiddenChange } = props;
    useEffect(() => {
        onDrawerHiddenChange(isDrawerHidden);
    }, [isDrawerHidden, onDrawerHiddenChange]);

    const [showCreateEvaluation, setShowCreateEvaluation] = useState<{
        petId: number | undefined;
        clientId: number | undefined;
    }>({
        petId: undefined,
        clientId: undefined
    });

    const isLastRecurrentAppointment = useMemo(
        () =>
            order && recurrentInfo
                ? order.items.appointments[0]?.appointment.duration.from.isSame(recurrentInfo.lastDate) ?? false
                : false,
        [order, recurrentInfo]
    );

    const existsEditedItemInOrder = useMemo(
        () =>
            [
                ...(order?.items.appointments.map(item => item.orderItem.id) ?? []),
                ...(order?.items.addOnServices.map(item => item.orderItem.id) ?? []),
                ...(order?.items.products.map(item => item.orderItem.id) ?? []),
                ...(order?.items.customs.map(item => item.orderItem.id) ?? [])
            ].includes(edit.orderItemId ?? 0),
        [order, edit.orderItemId]
    );

    const sortedPets = useMemo(() => (order ? sortPets(order) : []), [order]);

    useEffect(() => {
        if (sortedPets.length === 0) {
            setSelectedActivityPet(undefined);
            return;
        }

        if (!selectedActivityPet || !sortedPets.some(pet => pet.id === selectedActivityPet.id)) {
            setSelectedActivityPet(sortedPets[0]);
        }
    }, [sortedPets, selectedActivityPet]);

    useEffect(() => {
        if (sortedPets.length === 0) {
            setSelectedBelongingsPet(undefined);
            return;
        }

        if (!selectedBelongingsPet || !sortedPets.some(pet => pet.id === selectedBelongingsPet.id)) {
            setSelectedBelongingsPet(sortedPets[0]);
        }
    }, [sortedPets, selectedBelongingsPet]);

    const appointmentDateRange: Period | undefined = useMemo(() => {
        if (!order) return undefined;

        let from;
        let to;

        for (const item of order.items.appointments) {
            const appointmentFrom = item.appointment.duration.from;
            const appointmentTo = item.appointment.duration.to;

            if (!from || appointmentFrom.isBefore(from)) {
                from = appointmentFrom;
            }
            if (!to || appointmentTo.isAfter(to)) {
                to = appointmentTo;
            }
        }

        if (!from || !to) return undefined;

        return {
            from,
            to
        };
    }, [order]);

    const allPetsInactive = useMemo(
        () => sortedPets.every(pet => !pet.active || pet.deleted || pet.deceased),
        [sortedPets]
    );

    const orderItemsByPet = useMemo(() => (order ? groupOrderItemsByPet(order) : new Map()), [order]);

    const hasDaycareOrBoarding = useMemo(() => {
        return (
            order?.items.appointments.some(
                appointment =>
                    appointment.appointment.services[0]?.businessArea?.id === 'daycare' ||
                    appointment.appointment.services[0]?.businessArea?.id === 'boarding'
            ) || false
        );
    }, [order]);

    const orderEditContext = useMemo<OrderEditContext>(
        () => ({
            isOwner: auth.user?.role?.id === OWNER_ID,
            reopenClosedBookings: permissions.checkout.reopenClosedBookings,
            editPrices: permissions.checkout.editPrices
        }),
        [auth.user?.role?.id, permissions.checkout.reopenClosedBookings, permissions.checkout.editPrices]
    );

    const appointmentStatusIds = useMemo(
        () => order?.items.appointments.map(item => item.appointment.status.id) ?? [],
        [order]
    );

    const orderClosedAt = useMemo(
        () =>
            order
                ? getOrderClosedAtFromAppointments(order.items.appointments.map(item => item.appointment))
                : undefined,
        [order]
    );

    const nowInTimezone = useMemo(() => moment.tz(timezone), [timezone]);

    const appointmentById = useMemo(() => {
        const map = new Map<number, AppointmentOrderItem['appointment']>();
        (order?.items.appointments ?? []).forEach(item => {
            if (item.appointment.id != null) {
                map.set(item.appointment.id, item.appointment);
            }
        });
        return map;
    }, [order]);

    const canAddItemsAndPets = useMemo(
        () => canAddToOrder(appointmentStatusIds, orderEditContext, orderClosedAt, nowInTimezone),
        [appointmentStatusIds, orderEditContext, orderClosedAt, nowInTimezone]
    );

    const canEditAppointmentItem = useCallback(
        (appointmentId: number, statusId: number) => {
            const closedAt = appointmentById.get(appointmentId)?.closedAt;
            return canEditAppointmentItems(statusId, orderEditContext, closedAt, nowInTimezone);
        },
        [appointmentById, orderEditContext, nowInTimezone]
    );

    const canEditBookingFromHeader = useMemo(
        () =>
            (order?.items.appointments ?? []).some(
                item =>
                    item.appointment.id != null &&
                    canEditAppointmentItem(item.appointment.id, item.appointment.status.id)
            ),
        [order, canEditAppointmentItem]
    );

    const isOrderClosed = !canEditBookingFromHeader;

    const hasAddonTasks = useMemo(() => (order?.addonTasks?.length ?? 0) > 0, [order]);

    const feedingTasksCount = useMemo(() => {
        if (!order) return 0;
        return order.items.appointments.reduce((total, item) => {
            const count = (item.appointment.tasks ?? []).filter(
                task => task.feeding?.feedingMomentTypeId !== undefined
            ).length;
            return total + count;
        }, 0);
    }, [order]);

    const tasksCount = useMemo(() => {
        if (!order) return 0;

        const appointmentTasksCount = (order.items?.appointments ?? []).reduce((total, item) => {
            const tasks = item.appointment?.tasks ?? [];

            return (
                total +
                tasks.filter(
                    task =>
                        !(
                            task.appointmentStatus === AppointmentStatus.CANCELLED ||
                            task.appointmentStatus === AppointmentStatus.NO_SHOW
                        )
                ).length
            );
        }, 0);

        const addonTasksCount =
            order.addonTasks?.filter(
                task =>
                    !(
                        task.appointmentStatus === AppointmentStatus.CANCELLED ||
                        task.appointmentStatus === AppointmentStatus.NO_SHOW
                    )
            ).length ?? 0;

        return appointmentTasksCount + addonTasksCount;
    }, [order, ordersStatus]);

    const medsTasksCount = useMemo(() => {
        if (!order) return 0;
        return order.items.appointments.reduce((total, item) => {
            const count = (item.appointment.tasks ?? []).filter(
                task =>
                    task.medication !== undefined &&
                    task.medication !== null &&
                    Object.keys(task.medication).length > 0 &&
                    !task.feeding
            ).length;
            return total + count;
        }, 0);
    }, [order]);

    const belongingsCount = useMemo(() => {
        const countsByPet = new Map<number, number>();

        (bookingBelongingsPage?.data ?? [])
            .filter(entry => entry.bookingId === props.bookingId)
            .forEach(entry => {
                countsByPet.set(entry.petId, entry.belongings?.length ?? 0);
            });

        if (savedBookingBelonging?.bookingId === props.bookingId) {
            countsByPet.set(savedBookingBelonging.petId, savedBookingBelonging.belongings.length);
        }

        if (belongingsStatus === BelongingsStatus.BookingBelongingsSaveDestroyed && selectedBelongingsPet?.id != null) {
            countsByPet.set(selectedBelongingsPet.id, 0);
        }

        return Array.from(countsByPet.values()).reduce((total, count) => total + count, 0);
    }, [bookingBelongingsPage, props.bookingId, savedBookingBelonging, belongingsStatus, selectedBelongingsPet]);

    const loadBookingBelongings = useCallback(() => {
        dispatch(fetchBookingBelongingsThunk(apiClientWrapper, { bookingId: props.bookingId }));
    }, [dispatch, apiClientWrapper, props.bookingId]);

    const isRequestedOrder = (order?.items.appointments ?? []).some(
        item => item.appointment.status.id === AppointmentStatus.REQUESTED
    );

    const isDeclinedOrder = (order?.items.appointments ?? []).some(
        item => item.appointment.status.id === AppointmentStatus.DECLINED
    );

    const hasActivePrimaryService = useMemo(
        () => order?.items.appointments.some(item => !cancelledStatus.includes(item.appointment.status.id)) ?? false,
        [order]
    );

    const headerTitle = isRequestedOrder ? 'Online Booking Request' : edit.order ? 'Edit Booking' : 'Booking Detail';

    const hasOnlyOneService = (order?.items.appointments ?? []).length === 1;
    const hasOnlyOnePet = sortedPets.length === 1;

    const showAddPetButton =
        !loading.pets &&
        clientPets
            .filter(pet => !pet.deleted && pet.active)
            .some(pet => !sortedPets.map(orderPet => orderPet.id).includes(pet.id));

    const recurringUuid = order?.items.appointments[0]?.appointment.recurringUuid;
    const inRecurringSeries = isOrderInRecurringSeries(order);
    const seriesRecurringUuid = order?.items.appointments.find(item => item.appointment.recurringUuid)?.appointment
        .recurringUuid;

    const [seriesExtensionInfo, setSeriesExtensionInfo] = useState<RecurringSeriesExtensionInfo | undefined>(undefined);
    const [seriesExtension, setSeriesExtension] = useState<RecurringSeriesExtension>('idle');

    const loadSeriesExtensionInfo = async (): Promise<RecurringSeriesExtensionInfo | undefined> => {
        if (!inRecurringSeries || !seriesRecurringUuid) {
            setSeriesExtensionInfo(undefined);
            return undefined;
        }
        const info = await thunkDispatch(fetchRecurringSeriesExtensionInfoThunk(apiClientWrapper, seriesRecurringUuid));
        setSeriesExtensionInfo(info);
        return info;
    };

    const isLastSeriesOccurrence = useMemo(() => {
        if (!order || !seriesExtensionInfo) {
            return false;
        }
        if (seriesExtensionInfo.lastOccurrenceBookingId !== undefined) {
            return order.items.appointments.some(
                item => item.appointment.bookingId === seriesExtensionInfo.lastOccurrenceBookingId
            );
        }
        const lastAnchorDate = seriesExtensionInfo.lastOccurrenceAnchorDate;
        const anchor = order.items.appointments
            .map(item => item.appointment.duration.from)
            .reduce<Moment | undefined>(
                (earliest, from) => (!earliest || from.isBefore(earliest) ? from : earliest),
                undefined
            );
        return (
            lastAnchorDate !== undefined &&
            anchor !== undefined &&
            anchor.clone().tz(timezone).format('YYYY-MM-DD') === lastAnchorDate.format('YYYY-MM-DD')
        );
    }, [order, seriesExtensionInfo, timezone]);

    const canExtendSeries =
        !readOnly &&
        inRecurringSeries &&
        seriesExtensionInfo !== undefined &&
        seriesExtensionInfo.canExtend &&
        seriesExtensionInfo.status !== 'in_progress' &&
        seriesExtension !== 'processing' &&
        isLastSeriesOccurrence;

    const loadRecurrentInfo = () => {
        loadSeriesExtensionInfo();
        if (order?.items.appointments[0]?.appointment.recurringUuid) {
            setLoading(prev => ({ ...prev, recurrent: true }));
            const appointmentId = order?.items.appointments[0]?.appointment?.id;
            if (appointmentId) {
                dispatch(countRecurrentAppointmentsThunk(apiClientWrapper, appointmentId));
            }
        }
    };

    useEffect(() => {
        pendingEnrollmentRedeemRef.current = pendingEnrollmentRedeem;
    }, [pendingEnrollmentRedeem]);

    const queueEnrollmentRedeemAfterAdd = useCallback(
        (payload: PendingEnrollmentRedeemPayload) => {
            enrollmentRedeemGetOrderRetriesRef.current = 0;
            enrollmentRedeemPollScheduledRef.current = false;
            if (enrollmentRedeemPollTimeoutRef.current != null) {
                clearTimeout(enrollmentRedeemPollTimeoutRef.current);
                enrollmentRedeemPollTimeoutRef.current = null;
            }
            setPendingEnrollmentRedeem(payload);
            // Una sola carga inicial; el useEffect de pending + order re-ejecutaba getOrder al variar deps (p. ej. apiClientWrapper).
            if (payload.createdAppointmentId != null) {
                dispatch(getOrderByAppointmentThunk(apiClientWrapper, payload.createdAppointmentId));
            } else {
                dispatch(getOrderThunk(apiClientWrapper, payload.orderId));
            }
        },
        [apiClientWrapper, dispatch]
    );

    useEffect(() => {
        return () => {
            if (enrollmentRedeemPollTimeoutRef.current != null) {
                clearTimeout(enrollmentRedeemPollTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (!pendingEnrollmentRedeem) return;
        if (!order?.id || order.id !== pendingEnrollmentRedeem.orderId) return;

        const match = findAppointmentOrderItemForRedeem(order, pendingEnrollmentRedeem, timezone);
        const orderItemId = match?.orderItem?.id;
        if (orderItemId) {
            enrollmentRedeemPollScheduledRef.current = false;
            if (enrollmentRedeemPollTimeoutRef.current != null) {
                clearTimeout(enrollmentRedeemPollTimeoutRef.current);
                enrollmentRedeemPollTimeoutRef.current = null;
            }
            const enrollmentId = pendingEnrollmentRedeem.enrollmentId;
            const orderId = order.id;
            setPendingEnrollmentRedeem(null);
            const redeems: SaveOrderItemRedeem[] = [
                { orderItemId, redeem: { type: RedeemTypes.ENROLLMENT, id: enrollmentId } }
            ];
            dispatch(saveOrderRedeemsThunk(apiClientWrapper, orderId, redeems));
            return;
        }

        if (enrollmentRedeemPollScheduledRef.current) {
            return;
        }

        if (enrollmentRedeemGetOrderRetriesRef.current >= ENROLLMENT_REDEEM_GET_ORDER_MAX_POLLS) {
            enrollmentRedeemPollScheduledRef.current = false;
            if (enrollmentRedeemPollTimeoutRef.current != null) {
                clearTimeout(enrollmentRedeemPollTimeoutRef.current);
                enrollmentRedeemPollTimeoutRef.current = null;
            }
            setPendingEnrollmentRedeem(null);
            enrollmentRedeemFallbackReloadRef.current = true;
            dispatch(reloadOrderThunk(apiClientWrapper));
            return;
        }

        enrollmentRedeemPollScheduledRef.current = true;
        enrollmentRedeemPollTimeoutRef.current = setTimeout(() => {
            enrollmentRedeemPollTimeoutRef.current = null;
            enrollmentRedeemPollScheduledRef.current = false;
            enrollmentRedeemGetOrderRetriesRef.current += 1;
            const snap = pendingEnrollmentRedeemRef.current;
            if (!snap) return;
            if (snap.createdAppointmentId != null) {
                dispatch(getOrderByAppointmentThunk(apiClientWrapper, snap.createdAppointmentId));
            } else {
                dispatch(getOrderThunk(apiClientWrapper, snap.orderId));
            }
        }, ENROLLMENT_REDEEM_GET_ORDER_POLL_MS);
    }, [order, pendingEnrollmentRedeem, timezone, dispatch, apiClientWrapper]);

    useEffect(() => {
        if (props.orderId) {
            dispatch(getOrderThunk(apiClientWrapper, props.orderId));
        } else {
            dispatch(migrateBookingThunk(apiClientWrapper, props.bookingId));
        }
        dispatch(resetInvoices());
        loadBookingBelongings();
    }, []);

    useEffect(() => {
        setDepositPendingResolved(false);
        dispatch(clearAppointmentEditScopeThunk());
        orderEditScopeRef.current && dispatch(cancelOrderEditScopeThunk());
    }, [props.bookingId, props.orderId]);

    useEffect(() => {
        return () => {
            dispatch(cancelBookingEditScopeThunk());
            dispatch(clearAppointmentEditScopeThunk());
            orderEditScopeRef.current && dispatch(cancelOrderEditScopeThunk());
        };
    }, [dispatch]);

    useNonInitialEffect(() => {
        // Orders slice events while the client view is open belong to that flow (e.g. the membership
        // checkout). Reacting here would reload this booking's invoice over the one the checkout uses.
        // The booking order is re-fetched when the client view closes.
        if (clientViewOpen) return;

        switch (ordersStatus) {
            case OrdersStatus.GetSuccess:
            case OrdersStatus.MigrateSuccess:
                setLoading(prev => ({ ...prev, order: false }));
                if (order) {
                    const initial = order.notes || order.items.appointments[0]?.appointment?.notes || '';
                    lastSavedNotesRef.current = initial;
                    setNotes(initial);
                }
                order?.client.id && dispatch(fetchPetsThunk(apiClientWrapper, order?.client.id));
                if (staffs?.length === 0) {
                    dispatch(fetchStaffThunk());
                }
                if (order?.invoiceId !== undefined) {
                    dispatch(getInvoiceThunk(apiClientWrapper, order?.invoiceId));
                    setLoading(prev => ({ ...prev, invoice: true }));
                } else {
                    setLoading(prev => ({ ...prev, invoice: false }));
                }
                loadRecurrentInfo();

                break;
            case OrdersStatus.ReloadSuccess:
                closeDeleteConfirmationHandler();
                closeEditOrderItemHandler();
                closeDeletePetConfirmationHandler();
                closeReportHandler();
                setLoading(prev => ({ ...prev, order: false, bookingStatus: false }));
                setShowDeclineDialog(false);
                if (order) {
                    const initial = order.notes || order.items.appointments[0]?.appointment?.notes || '';
                    lastSavedNotesRef.current = initial;
                    setNotes(initial);
                }
                if (order?.invoiceId !== undefined) {
                    dispatch(getInvoiceThunk(apiClientWrapper, order?.invoiceId));
                    setLoading(prev => ({ ...prev, invoice: true }));
                } else {
                    setLoading(prev => ({ ...prev, invoice: false }));
                }
                loadRecurrentInfo();
                if (enrollmentRedeemFallbackReloadRef.current) {
                    enrollmentRedeemFallbackReloadRef.current = false;
                    props.onOrderUpdated?.();
                }
                break;
            case OrdersStatus.SaveOrderRedeemSuccess:
                dispatch(reloadOrderThunk(apiClientWrapper));
                props.onOrderUpdated?.();
                break;
            case OrdersStatus.SavingOrder:
            case OrdersStatus.SavingOrderItem:
            case OrdersStatus.DeletingOrderItem:
                if (inRecurringSeries && seriesRecurringUuid) {
                    props.onWatchRecurringSeries(seriesRecurringUuid);
                }
                break;
            case OrdersStatus.SaveOrderSuccess:
            case OrdersStatus.SaveOrderItemSuccess:
                if (inRecurringSeries && confirmedEditScope.current !== 'this_and_future') {
                    props.onRecurringSeriesChanged();
                }
                confirmedEditScope.current = undefined;
                break;
            case OrdersStatus.DeleteOrderItemSuccess:
                if (inRecurringSeries && confirmedEditScope.current !== 'this_and_future') {
                    props.onRecurringSeriesChanged();
                }
                confirmedEditScope.current = undefined;
                closeDeleteConfirmationHandler();
                closeEditOrderItemHandler();
                closeDeletePetConfirmationHandler();
                closeReportHandler();
                break;
            case OrdersStatus.DeletePetFromOrderSuccess:
                closeDeleteConfirmationHandler();
                closeEditOrderItemHandler();
                closeDeletePetConfirmationHandler();
                closeReportHandler();
                break;
            case OrdersStatus.NotFound:
                setRefreshModal(prev => ({ ...prev, show: true }));
                closeDeleteConfirmationHandler();
                closeDeletePetConfirmationHandler();
                break;
            case OrdersStatus.VerifyOutdatedSuccess:
                if (['view', 'add', 'report-builder'].includes(report.preshow)) {
                    if (orderOutdated?.order) {
                        setReport(prev => ({
                            ...prev,
                            prehow: 'none',
                            show: 'none',
                            appointmentId: undefined,
                            businessAreaId: undefined,
                            emailConfirmed: false
                        }));
                        setRefreshModal({ show: true });
                    } else {
                        setReport(prev => ({ ...prev, preshow: 'none', show: prev.preshow }));
                    }
                }
                break;
            case OrdersStatus.Error:
                if (confirmedEditScope.current === 'this_and_future') {
                    props.onRecurringSeriesUpdatingChange(false);
                }
                confirmedEditScope.current = undefined;
                setLoading(prev => ({ ...prev, order: false }));
                setRemove(prev => ({ ...prev, removing: false }));
                setRemovePet(prev => ({ ...prev, removing: false }));
                break;
        }
    }, [ordersStatus]);

    useNonInitialEffect(() => {
        switch (newBookingsStatus) {
            case NewBookingsStatus.NotFound:
                setRefreshModal(prev => ({ ...prev, show: true }));
                closeDeleteConfirmationHandler();
                closeDeletePetConfirmationHandler();
                break;
            case NewBookingsStatus.ChangeStatusSuccess:
                dispatch(reloadOrderThunk(apiClientWrapper));
                break;
            case NewBookingsStatus.UpdatingBookingAppointments:
            case NewBookingsStatus.UpdatingAppointment:
                if (inRecurringSeries && seriesRecurringUuid) {
                    props.onWatchRecurringSeries(seriesRecurringUuid);
                }
                break;
            case NewBookingsStatus.UpdateBookingAppointmentsSuccess:
                if (confirmedEditScope.current !== 'this_and_future') {
                    props.onRecurringSeriesChanged();
                }
                confirmedEditScope.current = undefined;
                dispatch(reloadOrderThunk(apiClientWrapper));
                break;
            case NewBookingsStatus.UpdateAppointmentSuccess:
                if (confirmedEditScope.current !== 'this_and_future') {
                    props.onRecurringSeriesChanged();
                }
                confirmedEditScope.current = undefined;
                dispatch(reloadOrderThunk(apiClientWrapper));
                break;
            case NewBookingsStatus.SingleRescheduleSuccess:
            case NewBookingsStatus.SingleMultipleRescheduleSuccess:
                dispatch(reloadOrderThunk(apiClientWrapper));
                break;
            case NewBookingsStatus.SaveMultipleSuccess:
                dispatch(reloadOrderThunk(apiClientWrapper));
                setLoading(prev => ({ ...prev, extend: false }));
                break;
            case NewBookingsStatus.DeleteDepositSuccess:
                if (depositToggleSaving) {
                    refreshDepositToggleData();
                }
                break;
            case NewBookingsStatus.Error:
                if (confirmedEditScope.current === 'this_and_future') {
                    props.onRecurringSeriesUpdatingChange(false);
                }
                confirmedEditScope.current = undefined;
                setDepositToggleSaving(false);
                setLoading(prev => ({ ...prev, bookingStatus: false, extended: false }));
        }
    }, [newBookingsStatus]);

    useNonInitialEffect(() => {
        switch (appointmentsStatus) {
            case AppointmentsStatus.CountRecurrentSuccess:
                setLoading(prev => ({ ...prev, recurrent: false, extend: false }));
                break;
            case AppointmentsStatus.DeleteSuccess:
                dispatch(reloadOrderThunk(apiClientWrapper));
                break;
            case AppointmentsStatus.NotFound:
                setRemove(prev => ({ ...prev, removing: false, orderItemId: undefined, type: undefined }));
                setRefreshModal(prev => ({ ...prev, show: true }));
                break;
            case AppointmentsStatus.Error:
                setRemove(prev => ({ ...prev, removing: false }));
                setLoading(prev => ({ ...prev, recurrent: false }));
                break;
        }
    }, [appointmentsStatus]);

    useNonInitialEffect(() => {
        switch (invoicesStatus) {
            case InvoicesStatus.GetInvoiceSuccess:
                setLoading(prev => ({ ...prev, invoice: false }));
                break;
            case InvoicesStatus.CreateDepositInvoiceSuccess:
                if (depositToggleSaving) {
                    refreshDepositToggleData();
                }
                break;
            case InvoicesStatus.Error:
                setDepositToggleSaving(false);
                setLoading(prev => ({ ...prev, invoice: false }));
                break;
        }
    }, [invoicesStatus]);

    useNonInitialEffect(() => {
        switch (petsStatus) {
            case PetsStatus.FetchSuccess:
                setLoading(prev => ({ ...prev, pets: false }));
                break;
            case PetsStatus.Error:
                setLoading(prev => ({ ...prev, pets: false }));
                break;
        }
    }, [petsStatus]);

    useNonInitialEffect(() => {
        switch (clientsStatus) {
            case ClientsStatus.GetSuccess:
                setLoading(prev => ({ ...prev, emailConfirmed: client ? confirmEmail(client) : false }));
                break;
            case ClientsStatus.Error:
                setReport(prev => ({ ...prev, emailConfirmed: false }));
                break;
        }
    }, [clientsStatus]);

    useNonInitialEffect(() => {
        if (readOnly || !order) return;
        const timer: NodeJS.Timer = setTimeout(() => {
            if (lastSavedNotesRef.current === notes) return;

            const appointments = order.items.appointments;
            if (appointments.length > 0) {
                appointments.forEach(item => {
                    if (item.appointment?.id) {
                        dispatch(changeAppointmentNotesThunk(apiClientWrapper, item.appointment.id, notes));
                    }
                });
                if (order.notes) {
                    dispatch(saveNotesThunk(apiClientWrapper, order.id, ''));
                }
            } else {
                dispatch(saveNotesThunk(apiClientWrapper, order.id, notes));
            }
            lastSavedNotesRef.current = notes;
        }, 600);
        return () => clearTimeout(timer);
    }, [notes, order, readOnly]);

    const editOrderHandler = () => {
        if (readOnly) return;
        setEdit(prev => ({ ...prev, order: true }));
    };

    const closeEditOrderHandler = () => {
        setEdit(prev => ({ ...prev, order: false }));
    };

    const saveRequestedBookingEditsHandler = () => {
        if (readOnly) return;
        setEdit(prev => ({ ...prev, order: false }));
        dispatch(reloadOrderThunk(apiClientWrapper));
        props.onOrderUpdated?.();
    };

    const editOrderItemHandler = (orderItemId: number) => {
        if (readOnly) return;
        setEdit(prev => ({ ...prev, order: false, orderItemId }));
    };

    const closeEditOrderItemHandler = () => {
        setEdit(prev => ({ ...prev, orderItemId: undefined }));
    };

    const addOrderItemHandler = (petId: number, orderItemType: OrderizableTypes) => {
        if (readOnly) return;
        setAdd(prev => ({ ...prev, petId, orderItemType }));
    };

    const closeAddOrderItemHandler = () => {
        setAdd(prev => ({ ...prev, petId: undefined, orderItemType: undefined, isEvaluation: false }));
    };

    const confirmDeleteHanlder = (orderItemId: number) => {
        if (readOnly) return;
        let label = '';
        let type: OrderizableTypes | undefined = undefined;

        if (order?.items.appointments.some(item => item.orderItem.id === orderItemId)) {
            label = 'Service';
            type = OrderizableTypes.APPOINTMENT;
        } else if (order?.items.addOnServices.some(item => item.orderItem.id === orderItemId)) {
            label = 'Add-On';
            type = OrderizableTypes.ADDON_SERVICE;
        } else if (order?.items.products.some(item => item.orderItem.id === orderItemId)) {
            label = 'Product';
            type = OrderizableTypes.PRODUCT;
        } else if (order?.items.customs.some(item => item.orderItem.id === orderItemId)) {
            label = 'Custom Item';
            type = OrderizableTypes.CUSTOM;
        }
        setRemove(prev => ({ ...prev, orderItemId, label, type }));
    };

    const deleteHanlder = () => {
        if (readOnly) return;
        setRemove(prev => ({ ...prev, removing: true }));

        if (remove.type === OrderizableTypes.APPOINTMENT) {
            const appointmentId = order?.items.appointments.find(item => item.orderItem.id === remove.orderItemId)
                ?.appointment.id;
            if (appointmentId && inRecurringSeries) {
                dispatch(
                    removeBookingAppointmentsThunk(
                        apiClientWrapper,
                        props.bookingId,
                        [appointmentId],
                        undefined,
                        INITIAL_BOOKING_EDIT_SCOPE_REQUEST
                    )
                );
                closeDeleteConfirmationHandler();
                return;
            }
            appointmentId && dispatch(deleteAppointmentThunk(apiClientWrapper, appointmentId));
        } else if (order && remove.orderItemId) {
            if (inRecurringSeries) {
                dispatch(
                    removeOrderItemsScopedThunk(
                        apiClientWrapper,
                        order.id,
                        [remove.orderItemId],
                        INITIAL_ORDER_EDIT_SCOPE_REQUEST
                    )
                );
                closeDeleteConfirmationHandler();
                return;
            }
            dispatch(deleteOrderItemThunk(apiClientWrapper, order.id, remove.orderItemId));
        }
    };

    const closeDeleteConfirmationHandler = () => {
        setRemove(prev => ({ ...prev, orderItemId: undefined, label: '', type: undefined, removing: false }));
    };

    const addReportHandler = (
        appointmentId: number,
        businessAreaId: string,
        serviceId?: number,
        pet?: AppointmentPet
    ) => {
        order && setReportClientEmail(appointmentId, order);
        const preshow = businessAreaId === 'daycare' || businessAreaId === 'boarding' ? 'report-builder' : 'add';
        setReport(prev => ({ ...prev, preshow, show: 'none', appointmentId, businessAreaId, serviceId, pet }));
        order?.id && dispatch(verifyOutdatedThunk(apiClientWrapper, order.id, order.version));
    };

    const viewReportHandler = (
        appointmentId: number,
        businessAreaId: string,
        serviceId?: number,
        pet?: AppointmentPet,
        evaluationReportId?: number
    ) => {
        order && setReportClientEmail(appointmentId, order);
        setReport(prev => ({
            ...prev,
            preshow: 'view',
            show: 'none',
            appointmentId,
            businessAreaId,
            serviceId,
            pet,
            evaluationReportId
        }));
        order?.id && dispatch(verifyOutdatedThunk(apiClientWrapper, order.id, order.version));
    };

    const editReportHandler = () => {
        setReport(prev => ({ ...prev, show: 'edit' }));
    };

    const closeReportHandler = () => {
        setReport(prev => ({
            ...prev,
            show: 'none',
            appointmentId: undefined,
            businessAreaId: undefined,
            emailConfirmed: false
        }));
    };

    const backAddEditReportEvaluationHandler = () => {
        setReport(prev => ({
            ...prev,
            preshow: 'none',
            show: 'none',
            appointmentId: undefined,
            businessAreaId: undefined,
            serviceId: undefined,
            pet: undefined
        }));
    };

    const confirmEmail = (client: Client) => {
        return !client.temporalEmail && !isEmpty(client.email);
    };

    const setReportClientEmail = (appointmentId: number, order: Order) => {
        const appointmentClientId = order.items.appointments.find(item => item.appointment.id === appointmentId)
            ?.appointment.customer.id;

        if (appointmentClientId === order.client.id) {
            setReport(prev => ({ ...prev, emailConfirmed: confirmEmail(order.client) }));
        } else if (client && client.id === appointmentClientId) {
            setReport(prev => ({ ...prev, emailConfirmed: confirmEmail(client) }));
        } else {
            appointmentClientId && dispatch(getClientThunk(apiClientWrapper, appointmentClientId));
        }
    };

    const confirmDeletePetHandler = (pet: Pet) => {
        if (readOnly) return;
        setRemovePet(prev => ({ ...prev, petId: pet.id, petName: pet.name }));
    };

    const deletePetHanlder = () => {
        if (readOnly) return;
        if (inRecurringSeries && order && removePet.petId) {
            const appointmentIds = order.items.appointments
                .filter(item => item.appointment.pet.id === removePet.petId)
                .map(item => item.appointment.id)
                .filter((id): id is number => id !== undefined);
            dispatch(
                removeBookingAppointmentsThunk(
                    apiClientWrapper,
                    props.bookingId,
                    appointmentIds,
                    undefined,
                    INITIAL_BOOKING_EDIT_SCOPE_REQUEST
                )
            );
            closeDeletePetConfirmationHandler();
            return;
        }
        setRemovePet(prev => ({ ...prev, removing: true }));
        order?.id && removePet.petId && dispatch(deletePetFromOrderThunk(apiClientWrapper, order.id, removePet.petId));
    };

    const markRecurringSeriesUpdating = (applyScope: ApplyScope) => {
        confirmedEditScope.current = applyScope;
        if (applyScope === 'this_and_future') {
            props.onRecurringSeriesUpdatingChange(true);
        }
    };

    const confirmBookingEditScopeHandler = (applyScope: ApplyScope) => {
        markRecurringSeriesUpdating(applyScope);
        dispatch(confirmBookingEditScopeThunk(apiClientWrapper, applyScope));
    };

    const cancelBookingEditScopeHandler = () => {
        dispatch(cancelBookingEditScopeThunk());
    };

    const confirmOrderEditScopeHandler = (applyScope: ApplyScope) => {
        markRecurringSeriesUpdating(applyScope);
        dispatch(confirmOrderEditScopeThunk(apiClientWrapper, applyScope));
    };

    const cancelOrderEditScopeHandler = () => {
        dispatch(cancelOrderEditScopeThunk());
    };

    const addedReportHandler = () => {
        dispatch(reloadOrderThunk(apiClientWrapper));
    };

    const closeDeletePetConfirmationHandler = () => {
        setRemovePet(prev => ({ ...prev, petId: undefined, petName: '', removing: false }));
    };

    // const closePetCard = () => setShowPetCard(prev => ({ ...prev, petId: undefined, optionSelected: undefined }));
    const closeClientView = () => {
        setShowClientView(prev => ({ ...prev, clientId: undefined }));

        // Restore this booking's order in the shared slice if the client view loaded another one.
        const bookingOrderId = props.orderId ?? bookingOrderRef.current?.id;
        if (bookingOrderId !== undefined && storeOrder?.id !== bookingOrderId) {
            setLoading(prev => ({ ...prev, order: true }));
            dispatch(getOrderThunk(apiClientWrapper, bookingOrderId));
        }
    };

    const refreshHandler = () => {
        setShowPetCard(prev => ({ ...prev, petId: undefined, optionSelected: undefined }));
        closeClientView();
        closeEditOrderHandler();
        closeEditOrderItemHandler();
        closeDeleteConfirmationHandler();
        closeDeletePetConfirmationHandler();
        setRefreshModal(prev => ({ ...prev, show: false }));
        setLoading(prev => ({ ...prev, order: true, invoice: true }));
        dispatch(reloadOrderThunk(apiClientWrapper));
        dispatch(fetchPetsThunk(apiClientWrapper, order?.client.id ?? 0));
    };

    const checkoutHandler = () => {
        if (readOnly || !hasActivePrimaryService) return;
        order && props.onCheckout && props.onCheckout(props.bookingId, order?.id);
    };

    const collectDepositCollectedHandler = () => {
        setCollectDepositOpen(false);
        setDepositPendingResolved(true);
        const oid = props.orderId ?? order?.id;
        if (oid !== undefined) {
            setLoading(prev => ({ ...prev, order: true, invoice: true }));
            dispatch(getOrderThunk(apiClientWrapper, oid));
        }
        if (orderDepositInvoiceId !== undefined && orderDepositInvoiceId !== null) {
            dispatch(getInvoiceThunk(apiClientWrapper, orderDepositInvoiceId));
        }
        props.onOrderUpdated?.();
    };

    const refreshDepositToggleData = () => {
        setDepositToggleSaving(false);
        if (orderDepositInvoiceId !== undefined && orderDepositInvoiceId !== null) {
            setLoading(prev => ({ ...prev, invoice: true }));
            dispatch(getInvoiceThunk(apiClientWrapper, orderDepositInvoiceId));
        }
    };

    const toggleDepositHandler = (enabled: boolean) => {
        if (readOnly || !props.bookingId) return;
        setDepositToggleSaving(true);
        if (enabled) {
            setDepositPendingResolved(false);
            dispatch(createDepositInvoiceThunk(apiClientWrapper, props.bookingId));
            return;
        }

        const depositId = invoice?.deposits?.list?.find(deposit => !deposit.paid)?.id;
        if (depositId !== undefined) {
            dispatch(deleteDepositThunk(apiClientWrapper, depositId));
        } else {
            setDepositToggleSaving(false);
        }
    };

    const declineHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (readOnly) return;
        event.stopPropagation();
        event.preventDefault();
        setShowDeclineDialog(true);
    };

    const confirmDeclineHandler = (sendNotification: boolean) => {
        if (readOnly) return;
        setLoading(prev => ({ ...prev, bookingStatus: true }));
        changeBookingStatus(AppointmentStatus.DECLINED, sendNotification);
    };

    const acceptHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
        if (readOnly) return;
        event.stopPropagation();
        event.preventDefault();
        setLoading(prev => ({ ...prev, bookingStatus: true }));
        changeBookingStatus(AppointmentStatus.BOOKED);
    };

    const changeBookingStatus = async (status: number, sendNotification = false) => {
        if (readOnly) return;
        await dispatch(changeBookingStatusThunk(apiClientWrapper, props.bookingId, status, false, sendNotification));
    };

    const goToCalendaryDayHandler = (order: Order) => {
        props.onClose();

        const start = getOrderStartTime(order);

        start !== null && history.push(`/calendar?calendar=${daily.id}&date=${start.format('YYYY-MM-DD')}`);
    };

    const closeRebookHandler = () => {
        setRebook({
            order: undefined,
            appointmentOrderItem: undefined
        });
    };

    const rebookedHandler = () => {
        if (rebook.order !== undefined && props.onRebookOrder) {
            props.onRebookOrder();
        } else if (rebook.appointmentOrderItem !== undefined && props.onRebookService) {
            props.onRebookService();
        } else {
            props.onClose();
        }
    };

    const handleAddEvaluation = (petId: number, orderItemType: OrderizableTypes) => {
        if (readOnly) return;
        setAdd(prev => ({ ...prev, petId, orderItemType, isEvaluation: true }));
    };

    const setOrderToRebook = () => {
        if (readOnly) return;
        if (order) {
            const orderToRebooked = cleanUpOrderForRebook(order);
            setRebook({
                order: orderToRebooked,
                appointmentOrderItem: undefined
            });
        }
    };

    const setServiceToRebook = (appointmentItem: AppointmentOrderItem) => {
        if (readOnly) return;
        setRebook({
            order: undefined,
            appointmentOrderItem: cleanUpServiceForRebook(appointmentItem)
        });
    };

    const showInvoiceHandler = () => {
        if (order?.paid && invoice) {
            setShowInvoiceView({ invoice });
        }
    };

    const extend = () => {
        if (readOnly) return;
        if (order) {
            setLoading(prev => ({ ...prev, extend: true }));

            const appointment = order.items.appointments[0]?.appointment;
            const orderItem = order.items.appointments[0]?.orderItem;
            if (!appointment || !orderItem) {
                setLoading(prev => ({ ...prev, extend: false }));
                return;
            }

            let startDate: Moment | null = appointment.duration.from.clone();

            switch (appointment.recurringFrecuency?.id) {
                case 'every_day':
                    startDate = startDate.add(1, 'day');
                    break;
                case 'every_week':
                    startDate = startDate.add(1, 'week');
                    break;
                case 'every_two_weeks':
                    startDate = startDate.add(2, 'week');
                    break;
                case 'every_three_weeks':
                    startDate = startDate.add(3, 'week');
                    break;
                case 'every_four_weeks':
                    startDate = startDate.add(4, 'week');
                    break;
                case 'every_month':
                    startDate = startDate.add(1, 'month');
                    break;
                case 'every_five_weeks':
                    startDate = startDate.add(5, 'week');
                    break;
                case 'every_six_weeks':
                    startDate = startDate.add(6, 'week');
                    break;
                case 'every_eight_weeks':
                    startDate = startDate.add(8, 'week');
                    break;
                case 'annually':
                    startDate = startDate.add(1, 'year');
                    break;
                default:
                    startDate = null;
            }

            if (startDate && auth.user) {
                const durationInMs = appointment.duration.to
                    .clone()
                    .diff(appointment.duration.from.clone(), 'milliseconds');
                const endDate = startDate.clone().add(durationInMs, 'milliseconds');

                const newAppointment: NewBookingAppointment = {
                    petId: appointment.pet.id,
                    serviceId: appointment.services[0].id,
                    date: startDate,
                    notes: appointment.notes,
                    createdByStaffId: appointment.createdBy ?? auth.user.staffId,
                    clientId: appointment.customer.id,
                    staffId: appointment.services[0].staff?.id,
                    dateEnd: endDate,
                    orderItemPrice: Number(orderItem.amount),
                    discount: orderItem.discount
                };

                dispatch(
                    saveMultipleBookingThunk(
                        apiClientWrapper,
                        [newAppointment],
                        undefined,
                        appointment.recurringFrecuency?.id,
                        appointment.recurringUuid,
                        false
                    )
                );
            }
        }
    };

    const extendSeries = async (): Promise<boolean> => {
        if (readOnly || !seriesRecurringUuid || seriesExtension !== 'idle') {
            return false;
        }
        setSeriesExtension('requesting');
        const series = await thunkDispatch(extendRecurringSeriesThunk(apiClientWrapper, seriesRecurringUuid));
        if (!series) {
            setSeriesExtension('idle');
            return false;
        }
        if (series.status === 'in_progress') {
            setSeriesExtension('processing');
            props.onRecurringSeriesUpdatingChange(true);
            props.onWatchRecurringSeries(seriesRecurringUuid, 'extend');
        } else {
            props.onRecurringSeriesFinished('extend');
        }
        return true;
    };

    useNonInitialEffect(() => {
        setSeriesExtension('idle');
        loadSeriesExtensionInfo();
    }, [props.recurringSeriesFinishedKey]);

    useEffect(() => {
        if (seriesExtension !== 'processing') {
            return;
        }
        const timer = setTimeout(async () => {
            const info = await loadSeriesExtensionInfo();
            if (info && info.status !== 'in_progress') {
                props.onRecurringSeriesFinished('extend');
            }
        }, SERIES_EXTENSION_FALLBACK_MS);
        return () => clearTimeout(timer);
    }, [seriesExtension]);

    const hasEvaluationService = () => {
        return (
            order?.items.appointments.some(appointment =>
                appointment?.appointment?.services?.some(service => service?.businessArea?.id === 'evaluation')
            ) || false
        );
    };

    const setActiveTabWithPanels = (tab: Parameters<typeof setActiveTab>[0]) => {
        if (tab !== 'activities') {
            setShowActivityHistory(false);
        }

        setActiveTab(tab);
    };

    return (
        <>
            {!isDrawerHidden && (
                <>
                    <SidePanel
                        side="right"
                        showCloseButton={!showTwoWays && !showActivityHistory}
                        onClose={props.onClose}
                        zIndex={props.zIndex}
                    >
                        {!['add', 'edit', 'view'].includes(report.show) &&
                            (edit.orderItemId === undefined || !existsEditedItemInOrder) &&
                            add.orderItemType === undefined &&
                            !addPet && (
                                <Box className={classes.container}>
                                    <Box className={clsx(classes.headerContainer, classes.horizontalPaddings)}>
                                        <OrderDetailHeader
                                            title={loading.order ? '' : headerTitle}
                                            loading={
                                                loading.order ||
                                                loading.invoice ||
                                                savingStatusAppointmentId !== undefined
                                            }
                                            withoutOptions={isDeclinedOrder || readOnly}
                                            allPetsInactive={allPetsInactive}
                                            editing={edit.order}
                                            paid={order?.paid}
                                            displayPaid={order?.displayPaid}
                                            orderClosed={isOrderClosed}
                                            onlyOnePet={isRequestedOrder ? false : sortedPets.length === 1}
                                            withoutRebook={isRequestedOrder}
                                            onClose={props.onClose}
                                            onBack={edit.order ? closeEditOrderHandler : undefined}
                                            onEdit={editOrderHandler}
                                            onRebook={setOrderToRebook}
                                            onShowInvoice={showInvoiceHandler}
                                            onShowLog={() => props.onShowActivityLog?.()}
                                            onDelete={() => {}}
                                            onPrint={() => setShowPrint(true)}
                                            recurringUuid={recurringUuid}
                                            isRecurringSeriesOpen={props.isRecurringSeriesOpen}
                                            onOpenRecurringSeries={props.onOpenRecurringSeries}
                                            zIndex={props.zIndex != null ? props.zIndex + 100 : undefined}
                                        />
                                    </Box>

                                    {/* Tabs */}
                                    {loading.order ||
                                    loading.invoice ||
                                    savingStatusAppointmentId !== undefined ||
                                    edit.order ? null : (
                                        <div className={classes.tabs}>
                                            <div className={clsx(classes.horizontalPaddings, classes.tabsScroller)}>
                                                <button
                                                    onClick={() => setActiveTabWithPanels('details')}
                                                    className={clsx(classes.tab)}
                                                    data-active={activeTab === 'details'}
                                                >
                                                    Details
                                                </button>
                                                <button
                                                    onClick={() => setActiveTabWithPanels('activities')}
                                                    className={clsx(classes.tab)}
                                                    data-active={activeTab === 'activities'}
                                                >
                                                    Activities
                                                </button>
                                                {hasDaycareOrBoarding || hasAddonTasks ? (
                                                    <button
                                                        onClick={() => setActiveTabWithPanels('tasks')}
                                                        className={clsx(classes.tab)}
                                                        data-active={activeTab === 'tasks'}
                                                    >
                                                        Tasks
                                                        {tasksCount > 0 && (
                                                            <span className={classes.tabBadge}>{tasksCount}</span>
                                                        )}
                                                    </button>
                                                ) : null}
                                                {hasDaycareOrBoarding && (
                                                    <button
                                                        onClick={() => setActiveTabWithPanels('feeding')}
                                                        className={clsx(classes.tab)}
                                                        data-active={activeTab === 'feeding'}
                                                    >
                                                        Feeding
                                                        {feedingTasksCount > 0 && (
                                                            <span className={classes.tabBadge}>
                                                                {feedingTasksCount}
                                                            </span>
                                                        )}
                                                    </button>
                                                )}
                                                {hasDaycareOrBoarding && (
                                                    <button
                                                        onClick={() => setActiveTabWithPanels('meds')}
                                                        className={clsx(classes.tab)}
                                                        data-active={activeTab === 'meds'}
                                                    >
                                                        Meds
                                                        {medsTasksCount > 0 && (
                                                            <span className={classes.tabBadge}>{medsTasksCount}</span>
                                                        )}
                                                    </button>
                                                )}
                                                <button
                                                    onClick={() => setActiveTabWithPanels('belongings')}
                                                    className={clsx(classes.tab)}
                                                    data-active={activeTab === 'belongings'}
                                                >
                                                    Belongings
                                                    {belongingsCount > 0 && (
                                                        <span className={classes.tabBadge}>{belongingsCount}</span>
                                                    )}
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                    <div
                                        // DO NOT REMOVE THIS ID
                                        // This is used to trigger the infinite scroll for activities tab
                                        id="scrollable-content"
                                        className={classes.scrollableContent}
                                    >
                                        {/* TODO: Refactor this without prop drilling (React Context) */}
                                        {activeTab === 'details' && (
                                            <OrderDetailDetailsTab
                                                loading={loading}
                                                order={order}
                                                invoice={invoice}
                                                sortedPets={sortedPets}
                                                onAddEvaluation={handleAddEvaluation}
                                                onViewResults={props.onViewResults}
                                                orderItemsByPet={orderItemsByPet}
                                                notes={notes}
                                                recurrentInfo={recurrentInfo}
                                                isLastRecurrentAppointment={isLastRecurrentAppointment}
                                                canExtendSeries={canExtendSeries}
                                                seriesExtending={seriesExtension !== 'idle'}
                                                isRequestedOrder={isRequestedOrder}
                                                isDeclinedOrder={isDeclinedOrder}
                                                isOrderClosed={isOrderClosed}
                                                canAddItemsAndPets={canAddItemsAndPets}
                                                canEditAppointmentItem={canEditAppointmentItem}
                                                isEvaluation={hasEvaluationService()}
                                                hasOnlyOnePet={!!hasOnlyOnePet}
                                                hasOnlyOneService={hasOnlyOneService}
                                                showAddPetButton={showAddPetButton}
                                                edit={edit}
                                                savingStatusAppointmentId={savingStatusAppointmentId}
                                                resultsDrawerZIndex={
                                                    props.zIndex != null ? props.zIndex + 100 : undefined
                                                }
                                                setShowClientView={setShowClientView}
                                                setShowTwoWays={setShowTwoWays}
                                                goToCalendaryDayHandler={goToCalendaryDayHandler}
                                                extend={extend}
                                                extendSeries={extendSeries}
                                                editOrderItemHandler={editOrderItemHandler}
                                                addOrderItemHandler={addOrderItemHandler}
                                                confirmDeleteHanlder={confirmDeleteHanlder}
                                                viewReportHandler={viewReportHandler}
                                                addReportHandler={addReportHandler}
                                                confirmDeletePetHandler={confirmDeletePetHandler}
                                                setSavingStatusAppointmentId={setSavingStatusAppointmentId}
                                                setServiceToRebook={setServiceToRebook}
                                                setShowPetCard={setShowPetCard}
                                                setAddPet={setAddPet}
                                                setNotes={setNotes}
                                                classNames={classes}
                                                readOnly={readOnly}
                                                onOpenCollectDeposit={() => setCollectDepositOpen(true)}
                                                depositPendingResolved={depositPendingResolved}
                                                depositToggleLoading={depositToggleSaving}
                                                onToggleDeposit={toggleDepositHandler}
                                            />
                                        )}

                                        {activeTab === 'activities' && (
                                            <OrderDetailActivitiesTab
                                                pets={sortedPets}
                                                appointmentItems={order?.items.appointments ?? []}
                                                bookingId={props.bookingId}
                                                customerId={Number(order?.client.id)}
                                                dateLimits={appointmentDateRange}
                                                className={classes.horizontalPaddings}
                                                zIndex={props.zIndex ? props.zIndex + 10 : undefined}
                                                readOnly={readOnly}
                                                selectedPet={selectedActivityPet}
                                                onSelectedPetChange={setSelectedActivityPet}
                                                setShowActivityHistory={setShowActivityHistory}
                                            />
                                        )}

                                        {activeTab === 'tasks' && (hasDaycareOrBoarding || hasAddonTasks) && (
                                            <OrderDetailTasksTab
                                                order={order}
                                                pets={sortedPets}
                                                className={classes.horizontalPaddings}
                                                readOnly={readOnly}
                                            />
                                        )}

                                        {activeTab === 'belongings' && (
                                            <OrderDetailBelongingsTab
                                                pets={sortedPets}
                                                selectedPet={selectedBelongingsPet}
                                                onSelectedPetChange={setSelectedBelongingsPet}
                                                className={classes.horizontalPaddings}
                                                readOnly={readOnly}
                                                bookingId={props.bookingId}
                                                onSaved={loadBookingBelongings}
                                            />
                                        )}

                                        {activeTab === 'feeding' && hasDaycareOrBoarding && (
                                            <OrderDetailFeedingTab
                                                order={order}
                                                pets={sortedPets}
                                                className={classes.horizontalPaddings}
                                                readOnly={readOnly}
                                            />
                                        )}

                                        {activeTab === 'meds' && hasDaycareOrBoarding && (
                                            <OrderDetailMedsTab
                                                order={order}
                                                pets={sortedPets}
                                                className={classes.horizontalPaddings}
                                                readOnly={readOnly}
                                            />
                                        )}
                                    </div>
                                    <Box className={clsx(classes.footerContainer, classes.horizontalPaddings)}>
                                        {order?.paid ? (
                                            <InvoiceResume
                                                invoice={invoice}
                                                loadingInvoice={loading.invoice}
                                                loadingTip={loading.invoice}
                                                className={classes.invoiceResume}
                                            />
                                        ) : (
                                            <OrderSubtotalResume
                                                order={order}
                                                invoice={invoice}
                                                loadingOrder={loading.order}
                                                loadingInvoice={loading.invoice}
                                                cancelledStatus={cancelledStatus}
                                            />
                                        )}
                                        {!edit.order &&
                                            !loading.order &&
                                            !loading.invoice &&
                                            !isRequestedOrder &&
                                            permissions.checkout.takePayments && (
                                                <Button
                                                    label="Check Out"
                                                    color="black"
                                                    size="large"
                                                    disabled={
                                                        readOnly ||
                                                        remove.removing ||
                                                        savingStatusAppointmentId !== undefined ||
                                                        !hasActivePrimaryService
                                                    }
                                                    className={classes.checkoutButton}
                                                    onClick={checkoutHandler}
                                                />
                                            )}
                                        {isRequestedOrder && !edit.order && (
                                            <Box className={classes.requestButtonsContainer}>
                                                <Button
                                                    label="Decline"
                                                    size="large"
                                                    variant="danger"
                                                    className={classes.declineButton}
                                                    onClick={declineHandler}
                                                    loading={loading.bookingStatus}
                                                    disabled={readOnly}
                                                />
                                                <Button
                                                    label="Edit"
                                                    size="large"
                                                    variant="secondary"
                                                    color="black"
                                                    className={classes.editButton}
                                                    onClick={editOrderHandler}
                                                    disabled={readOnly || edit.order}
                                                />
                                                <Button
                                                    label="Accept"
                                                    size="large"
                                                    color="green"
                                                    className={classes.acceptButton}
                                                    onClick={acceptHandler}
                                                    loading={loading.bookingStatus}
                                                    disabled={readOnly}
                                                />
                                            </Box>
                                        )}
                                        {isRequestedOrder && edit.order && (
                                            <Button
                                                label="Save Booking"
                                                size="large"
                                                color="black"
                                                className={classes.requestSaveButton}
                                                onClick={saveRequestedBookingEditsHandler}
                                                disabled={
                                                    readOnly ||
                                                    loading.order ||
                                                    loading.invoice ||
                                                    savingStatusAppointmentId !== undefined
                                                }
                                            />
                                        )}
                                    </Box>
                                </Box>
                            )}
                        {edit.orderItemId && order && existsEditedItemInOrder && (
                            <EditOrderItem
                                order={order}
                                orderItemId={edit.orderItemId}
                                recurrentInfo={recurrentInfo}
                                hideRemove={hasOnlyOneService}
                                zIndex={props.zIndex}
                                onClose={closeEditOrderItemHandler}
                                onCloseOrderDetail={props.onClose}
                                onSaveSuccess={props.onOrderUpdated}
                                onDelete={() => confirmDeleteHanlder(edit.orderItemId!)}
                                onRebook={(appointmentItem: AppointmentOrderItem) => {
                                    setEdit(prev => ({ ...prev, orderItemId: undefined }));
                                    setRebook({
                                        order: undefined,
                                        appointmentOrderItem: appointmentItem
                                    });
                                }}
                            />
                        )}
                        {add.orderItemType && add.petId && order && (
                            <AddOrderItem
                                order={order}
                                recurrentInfo={!!recurrentInfo?.frecuency}
                                inRecurringSeries={inRecurringSeries}
                                bookingId={props.bookingId}
                                petId={add.petId}
                                type={add.orderItemType}
                                isEvaluation={add.isEvaluation}
                                onClose={closeAddOrderItemHandler}
                            />
                        )}
                        {addPet && order && (
                            <AddPet
                                order={order}
                                recurrentInfo={!!recurrentInfo?.frecuency}
                                inRecurringSeries={inRecurringSeries}
                                bookingId={props.bookingId}
                                onClose={() => setAddPet(false)}
                            />
                        )}
                        {report.show === 'view' &&
                            report.appointmentId &&
                            report.businessAreaId &&
                            (report.businessAreaId === 'evaluation' && report.serviceId && report.pet ? (
                                <AddEditEvaluationReport
                                    evaluationReportId={report.evaluationReportId}
                                    appointmentId={report.appointmentId}
                                    serviceId={report.serviceId}
                                    pet={report.pet}
                                    onBack={backAddEditReportEvaluationHandler}
                                    onClose={backAddEditReportEvaluationHandler}
                                    onSave={addedReportHandler}
                                />
                            ) : (
                                <OverDetail
                                    fullWindow
                                    fullHeight
                                >
                                    <ViewReport
                                        appointmentId={report.appointmentId}
                                        businessAreaId={report.businessAreaId}
                                        onBack={closeReportHandler}
                                        onClose={closeReportHandler}
                                        onEditGrooming={editReportHandler}
                                        onEditDental={editReportHandler}
                                    />
                                </OverDetail>
                            ))}
                        {report.show === 'edit' && report.appointmentId && report.businessAreaId && (
                            <OverDetail
                                fullWindow
                                fullHeight
                            >
                                <EditReport
                                    appointmentId={report.appointmentId!}
                                    businessAreaId={report.businessAreaId!}
                                    savePDF={true}
                                    onBack={closeReportHandler}
                                    onClose={closeReportHandler}
                                    onView={() => setReport(prev => ({ ...prev, show: 'view' }))}
                                    declined={false}
                                    emailConfigured={report.emailConfirmed}
                                />
                            </OverDetail>
                        )}
                        {report.show === 'add' &&
                            report.appointmentId &&
                            report.businessAreaId &&
                            (report.businessAreaId === 'evaluation' && report.serviceId && report.pet ? (
                                <AddEditEvaluationReport
                                    appointmentId={report.appointmentId}
                                    serviceId={report.serviceId}
                                    pet={report.pet}
                                    onBack={backAddEditReportEvaluationHandler}
                                    onClose={backAddEditReportEvaluationHandler}
                                    onSave={addedReportHandler}
                                />
                            ) : (
                                <OverDetail
                                    fullWindow
                                    fullHeight
                                >
                                    <CompleteReport
                                        appointmentId={report.appointmentId}
                                        businessAreaId={report.businessAreaId}
                                        onBack={closeReportHandler}
                                        onClose={closeReportHandler}
                                        declined={false}
                                        onlyAddReport={true}
                                        emailConfigured={report.emailConfirmed}
                                        onSave={addedReportHandler}
                                    />
                                </OverDetail>
                            ))}
                        {report.show === 'report-builder' &&
                            report.appointmentId &&
                            report.businessAreaId &&
                            report.pet &&
                            order &&
                            (() => {
                                const apptItem = order.items.appointments.find(
                                    item => item.appointment.id === report.appointmentId
                                );
                                if (!apptItem) return null;
                                return (
                                    <ReportBuilder
                                        pet={report.pet}
                                        petParentName={`${order.client.firstName} ${order.client.lastName}`}
                                        petParentPhone={order.client.phone || undefined}
                                        petParentEmail={report.emailConfirmed ? order.client.email : undefined}
                                        appointmentId={apptItem.appointment.id!}
                                        bookingId={props.bookingId}
                                        businessAreaId={report.businessAreaId as 'daycare' | 'boarding'}
                                        serviceFrom={apptItem.appointment.duration.from}
                                        serviceTo={apptItem.appointment.duration.to}
                                        onClose={closeReportHandler}
                                    />
                                );
                            })()}
                        {showInvoiceView.invoice && (
                            <OverDetail
                                fullWindow
                                fullHeight
                            >
                                <InvoiceView
                                    invoice={showInvoiceView.invoice}
                                    onBack={() => setShowInvoiceView(prev => ({ ...prev, invoice: undefined }))}
                                />
                            </OverDetail>
                        )}
                        {props.recurringSeriesPanel}
                    </SidePanel>

                    {order && (
                        <TwoWaySMSDrawer
                            hide={!showTwoWays}
                            onBack={() => setShowTwoWays(false)}
                            client={order?.client}
                            onClose={props.onClose}
                            offset={590}
                            hideBackdrop={true}
                            onShowClient={() =>
                                setShowClientView(prev => ({
                                    ...prev,
                                    clientId: order.client.id
                                }))
                            }
                            zIndex={10100}
                        />
                    )}
                    {order && (
                        <ActivityHistoryDrawer
                            open={showActivityHistory}
                            onBack={() => setShowActivityHistory(false)}
                            pets={sortedPets}
                            selectedPet={selectedActivityPet}
                            customerId={Number(order?.client.id)}
                            dateLimits={appointmentDateRange}
                            zIndex={props.zIndex}
                        />
                    )}
                </>
            )}
            {collectDepositOpen && (
                <SidePanel
                    side="right"
                    showCloseButton={true}
                    onClose={() => setCollectDepositOpen(false)}
                    zIndex={props.zIndex != null ? props.zIndex + 100 : 1400}
                    className={classes.collectDepositDrawerRoot}
                >
                    <Box
                        display="flex"
                        flexDirection="column"
                        height="100%"
                    >
                        <Box className={classes.collectDepositHeaderWrap}>
                            <CreateBookingHeader
                                title="Collect Deposit"
                                onBack={() => setCollectDepositOpen(false)}
                                onClose={() => setCollectDepositOpen(false)}
                            />
                        </Box>
                        <Box className={classes.collectDepositDrawerBody}>
                            <CollectDeposit
                                bookingId={props.bookingId}
                                orderCheckoutInvoiceId={orderDepositInvoiceId!}
                                allowSkipAndBook={false}
                                onCollected={collectDepositCollectedHandler}
                            />
                        </Box>
                    </Box>
                </SidePanel>
            )}
            {remove.orderItemId && (
                <ConfirmDialog
                    open={true}
                    title={`Delete ${remove.label}`}
                    question={
                        <Typography>
                            Are you sure you want to <strong>delete</strong> this {remove.label}?
                        </Typography>
                    }
                    cancelButtonLabel="No"
                    confirmButtonLabel="Yes"
                    processing={remove.removing}
                    onCancel={closeDeleteConfirmationHandler}
                    onConfirm={deleteHanlder}
                    zIndex={props.zIndex ? props.zIndex + 100 : undefined}
                />
            )}
            {removePet.petId && (
                <ConfirmDialog
                    open={true}
                    title={`Delete Pet`}
                    question={
                        <Typography>
                            Are you sure you want to <strong>delete</strong> this for{' '}
                            <strong>{removePet.petName}</strong>?
                        </Typography>
                    }
                    cancelButtonLabel="No"
                    confirmButtonLabel="Yes"
                    processing={removePet.removing}
                    onCancel={closeDeletePetConfirmationHandler}
                    onConfirm={deletePetHanlder}
                    zIndex={props.zIndex ? props.zIndex + 100 : undefined}
                />
            )}
            <RecurringEditScopeDialog
                open={pendingBookingEdit !== undefined}
                title="Update Recurring Booking"
                noun="booking"
                futureScopeDescription={pendingBookingEdit?.summary.message}
                isSaving={newBookingsStatus === NewBookingsStatus.UpdatingBookingAppointments}
                zIndex={props.zIndex ? props.zIndex + 100 : undefined}
                onCancel={cancelBookingEditScopeHandler}
                onConfirm={confirmBookingEditScopeHandler}
            />
            <RecurringEditScopeDialog
                open={orderEditScope !== undefined}
                title={ORDER_EDIT_SCOPE_TITLES[orderEditScope?.edit.type ?? 'update_item']}
                noun="booking"
                futureScopeDescription={orderEditScope?.summary.message}
                isSaving={
                    orderEditScope !== undefined &&
                    (ordersStatus === OrdersStatus.SavingOrder ||
                        ordersStatus === OrdersStatus.SavingOrderItem ||
                        ordersStatus === OrdersStatus.DeletingOrderItem)
                }
                zIndex={props.zIndex ? props.zIndex + 100 : undefined}
                onCancel={cancelOrderEditScopeHandler}
                onConfirm={confirmOrderEditScopeHandler}
            />
            <AppointmentEditScopeDialogContainer
                origin="order_detail"
                zIndex={props.zIndex ? props.zIndex + 100 : undefined}
                onConfirm={markRecurringSeriesUpdating}
            />
            {refreshModal.show && (
                <RefreshModal
                    onRefresh={refreshHandler}
                    onClose={() => setRefreshModal(prev => ({ ...prev, show: false }))}
                />
            )}
            {showDeclineDialog && (
                <DeclineConfirmation
                    loading={loading.bookingStatus}
                    onCancel={() => setShowDeclineDialog(false)}
                    onConfirm={sendNotification => confirmDeclineHandler(sendNotification)}
                />
            )}
            {(rebook.order || rebook.appointmentOrderItem) && (
                <CreateBookingDrawer
                    parentID={order?.client.id}
                    petID={
                        rebook?.order?.items?.appointments[0]?.appointment?.pet?.id ??
                        rebook?.appointmentOrderItem?.appointment?.pet?.id
                    }
                    order={rebook.order}
                    flow={
                        (rebook?.appointmentOrderItem?.appointment?.services[0]?.businessArea?.id as
                            | 'grooming'
                            | 'daycare'
                            | 'boarding'
                            | undefined) ?? undefined
                    }
                    appointmentItem={rebook.appointmentOrderItem}
                    onClose={closeRebookHandler}
                    onBooked={rebookedHandler}
                />
            )}
            {/*showCreateEvaluation.petId && showCreateEvaluation.clientId && (
                <CreateBookingDrawer
                    parentID={showCreateEvaluation.clientId}
                    petID={showCreateEvaluation.petId}
                    isEvaluation={true}
                    onClose={closeCreateEvaluationHandler}
                    onBooked={rebookedEvaluationHandler}
                    onAddEvaluation={handleAddEvaluation}
                />
            )*/}
            {showPetCard.petId && (
                <PetCard
                    petId={showPetCard.petId}
                    optionMenuSelected={showPetCard.optionSelected}
                    onSaved={refreshHandler}
                    onClose={refreshHandler}
                />
            )}
            {showClientView.clientId && (
                <OverFullWindow
                    className={classes.clientOverWindow}
                    onClose={closeClientView}
                >
                    <ClientView
                        clientId={showClientView.clientId}
                        hideHeader={true}
                        onClose={closeClientView}
                        onClientSaved={refreshHandler}
                    />
                </OverFullWindow>
            )}
            {showPrint && order && (
                <PrintBookingDetail
                    order={order}
                    bookingId={props.bookingId}
                    onClose={() => setShowPrint(false)}
                    onAfterClose={() => {}}
                />
            )}
        </>
    );
};

interface SelectedOrderDetailBooking {
    bookingId: number;
    orderId?: number;
    startInEditMode?: boolean;
}

export const OrderDetail: FunctionComponent<OrderDetailProps> = props => {
    const [selected, setSelected] = useState<SelectedOrderDetailBooking>({
        bookingId: props.bookingId,
        orderId: props.orderId,
        startInEditMode: props.startInEditMode
    });
    const [seriesUuid, setSeriesUuid] = useState<string | undefined>(undefined);
    const [isDrawerHidden, setIsDrawerHidden] = useState(false);
    const [watchedSeries, setWatchedSeries] = useState<
        { uuid: string; reason: RecurringSeriesWatchReason } | undefined
    >(undefined);
    const [seriesRefreshKey, setSeriesRefreshKey] = useState(0);
    const [seriesFinishedKey, setSeriesFinishedKey] = useState(0);
    const [isSeriesUpdating, setIsSeriesUpdating] = useState(false);
    const isStackedRecurring = useMediaQuery(STACKED_PANELS_QUERY);

    const dispatch = useDispatch();

    const watchSeriesHandler = useCallback((uuid: string, reason: RecurringSeriesWatchReason = 'edit') => {
        setWatchedSeries({ uuid, reason });
    }, []);

    const seriesFinishedHandler = useCallback(
        (reason: RecurringSeriesWatchReason) => {
            setIsSeriesUpdating(false);
            setSeriesRefreshKey(key => key + 1);
            if (reason === 'extend') {
                setWatchedSeries(undefined);
                setSeriesFinishedKey(key => key + 1);
                dispatch(showSuccess('Recurring Series Extended'));
            } else {
                dispatch(showSuccess('Recurrent Appointments Edited'));
            }
        },
        [dispatch]
    );

    const seriesChannelFinishedHandler = useCallback(() => {
        seriesFinishedHandler(watchedSeries?.reason ?? 'edit');
    }, [seriesFinishedHandler, watchedSeries?.reason]);

    const refreshSeriesHandler = useCallback(() => {
        setSeriesRefreshKey(key => key + 1);
    }, []);

    useRecurringSeriesChannel(watchedSeries?.uuid, seriesChannelFinishedHandler);

    useNonInitialEffect(() => {
        setSelected({ bookingId: props.bookingId, orderId: props.orderId, startInEditMode: props.startInEditMode });
    }, [props.bookingId, props.orderId]);

    const selectSeriesBookingHandler = useCallback(
        (occurrence: RecurringSeriesOccurrence) => {
            const bookingId = occurrence.bookingId;
            if (bookingId === undefined || bookingId === selected.bookingId) {
                return;
            }
            setSelected({ bookingId, orderId: occurrence.orderId, startInEditMode: false });
        },
        [selected.bookingId]
    );

    return (
        <>
            <OrderDetailProvider key={selected.bookingId}>
                <OrderDetailContent
                    {...props}
                    bookingId={selected.bookingId}
                    orderId={selected.orderId}
                    startInEditMode={selected.startInEditMode}
                    isRecurringSeriesOpen={seriesUuid !== undefined}
                    onOpenRecurringSeries={setSeriesUuid}
                    onDrawerHiddenChange={setIsDrawerHidden}
                    onWatchRecurringSeries={watchSeriesHandler}
                    onRecurringSeriesFinished={seriesFinishedHandler}
                    recurringSeriesFinishedKey={seriesFinishedKey}
                    onRecurringSeriesUpdatingChange={setIsSeriesUpdating}
                    onRecurringSeriesChanged={refreshSeriesHandler}
                    recurringSeriesPanel={
                        seriesUuid && isStackedRecurring ? (
                            <RecurringSeriesViewPanel
                                inline
                                recurringUuid={seriesUuid}
                                refreshKey={seriesRefreshKey}
                                isUpdating={isSeriesUpdating}
                                selectedBookingId={selected.bookingId}
                                onSelectBooking={selectSeriesBookingHandler}
                                onClose={() => setSeriesUuid(undefined)}
                            />
                        ) : undefined
                    }
                />
            </OrderDetailProvider>
            {seriesUuid && !isStackedRecurring && !isDrawerHidden && (
                <RecurringSeriesViewPanel
                    recurringUuid={seriesUuid}
                    zIndex={props.zIndex != null ? props.zIndex + 1 : undefined}
                    refreshKey={seriesRefreshKey}
                    isUpdating={isSeriesUpdating}
                    selectedBookingId={selected.bookingId}
                    onSelectBooking={selectSeriesBookingHandler}
                    onClose={() => setSeriesUuid(undefined)}
                />
            )}
        </>
    );
};

export default OrderDetail;
